import { render, staticRenderFns } from "./thread-item.vue?vue&type=template&id=35ab7476&scoped=true"
import script from "./thread-item.vue?vue&type=script&lang=js"
export * from "./thread-item.vue?vue&type=script&lang=js"
import style0 from "./thread-item.vue?vue&type=style&index=0&id=35ab7476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ab7476",
  null
  
)

export default component.exports